import React from "react";
import {
  FiEye,
  FiMessageSquare,
  FiTrash2,
  FiEdit2,
  FiExternalLink,
  FiMapPin,
  FiImage,
} from "react-icons/fi";
import { formatCurrency, formatDate, resolveAssetUrl } from "../utils/formatters";
import "./PromotionTableView.css";

const PromotionTableView = ({
  promotions = [],
  onViewDetails,
  onOpenComments,
  onDelete,
  canDelete = false,
  onEdit,
  canEditPromotion = () => true,
}) => {
  if (promotions.length === 0) {
    return null;
  }

  return (
    <div className="promo-table-wrap">
      <table className="promo-table">
        <thead>
          <tr>
            <th>Project</th>
            <th>Type</th>
            <th>Location</th>
            <th>Starting Cost</th>
            <th>Partner</th>
            <th>Created</th>
            <th className="promo-table__actions-head">Actions</th>
          </tr>
        </thead>
        <tbody>
          {promotions.map((promo) => {
            const propImagesList = Array.isArray(promo.propertyImages) ? promo.propertyImages : [];
            const standardImagesList = Array.isArray(promo.images) ? promo.images : [];
            const allImages = propImagesList.length > 0 ? propImagesList : standardImagesList;
            const firstImg = allImages.length > 0 ? allImages[0] : null;
            const imgUrl = firstImg?.image_url || firstImg?.imagePath || firstImg?.url;
            const resolvedImg = imgUrl ? resolveAssetUrl(imgUrl) : null;

            const typeName =
              typeof promo.property_type === "object"
                ? promo.property_type?.name
                : promo.property_type || "N/A";

            const partnerName =
              promo.partner?.first_name || promo.user?.first_name
                ? `${promo.partner?.first_name || promo.user?.first_name} ${
                    promo.partner?.last_name || promo.user?.last_name || ""
                  }`.trim()
                : "Partner";

            return (
              <tr key={promo.id}>
                <td>
                  <div className="promo-table__project-cell">
                    <div
                      className="promo-table__thumb"
                      onClick={() => onViewDetails(promo)}
                    >
                      {resolvedImg ? (
                        <img
                          src={resolvedImg}
                          alt={promo.project_name}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <FiImage className="promo-table__thumb-placeholder" />
                      )}
                    </div>
                    <div className="promo-table__project-info">
                      <span
                        className="promo-table__project-name"
                        onClick={() => onViewDetails(promo)}
                      >
                        {promo.project_name || "Untitled Promotion"}
                      </span>
                      {promo.area_name && (
                        <span className="promo-table__project-sub">
                          {promo.area_name}
                        </span>
                      )}
                    </div>
                  </div>
                </td>

                <td>
                  <span className="promo-table__type-badge">{typeName}</span>
                </td>

                <td>
                  <div className="promo-table__location-cell">
                    <FiMapPin size={13} className="text-danger" />
                    <span>
                      {[promo.city_name, promo.state_name].filter(Boolean).join(", ") ||
                        "N/A"}
                    </span>
                  </div>
                </td>

                <td>
                  <span className="promo-table__cost">
                    {formatCurrency(promo.starting_cost)}
                  </span>
                </td>

                <td>
                  <span className="promo-table__partner-name">{partnerName}</span>
                </td>

                <td>
                  <span className="promo-table__date">
                    {formatDate(promo.created_on)}
                  </span>
                </td>

                <td>
                  <div className="promo-table__actions">
                    <button
                      type="button"
                      className="promo-table__action-btn promo-table__action-btn--primary"
                      onClick={() => onViewDetails(promo)}
                      title="View Details"
                    >
                      <FiEye size={15} />
                    </button>

                    <button
                      type="button"
                      className="promo-table__action-btn promo-table__action-btn--secondary"
                      onClick={() => onOpenComments(promo)}
                      title="Comments"
                    >
                      <FiMessageSquare size={15} />
                    </button>

                    {promo.promotion_url && (
                      <a
                        href={
                          promo.promotion_url.startsWith("http")
                            ? promo.promotion_url
                            : `https://${promo.promotion_url}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="promo-table__action-btn promo-table__action-btn--link"
                        title="Open External URL"
                      >
                        <FiExternalLink size={15} />
                      </a>
                    )}

                    {onEdit && canEditPromotion(promo) && (
                      <button
                        type="button"
                        className="promo-table__action-btn"
                        onClick={() => onEdit(promo)}
                        title="Edit"
                        aria-label="Edit Promotion"
                      >
                        <FiEdit2 size={15} />
                      </button>
                    )}

                    {canDelete && (
                      <button
                        type="button"
                        className="promo-table__action-btn promo-table__action-btn--danger"
                        onClick={() => onDelete(promo)}
                        title="Delete"
                      >
                        <FiTrash2 size={15} />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PromotionTableView;
